export default __webpack_public_path__ + "static/trend-experiment-calculation-light-8c04fdbe62b3cc813700311eeb164a95.png";